module.exports = __webpack_public_path__ + "img/3dm.25cd930d.svg";